import { createSelector } from 'reselect';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectAnonymousUserState = (state: AppStateType) => state.users.anonymousUser;

export const selectAnonymousUserCharacter = createSelector([selectAnonymousUserState], state => state?.character);

export const selectAnonymousUserProfileId = createSelector([selectAnonymousUserState], state => state?.profileId);

export const selectIsLoadingAnonymousData = createSelector([selectAnonymousUserState], state => state?.isLoading);
